import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteGuard } from "@/components/permissions/route-guard";

export const Route = createFileRoute("/_authenticated/documents")({
  component: DocumentsLayout,
});

function DocumentsLayout() {
  return (
    <RouteGuardPermissions
      permissions={[{ module: "document_records", actions: ["read"] }]}
    >
      <Outlet />
    </RouteGuardPermissions>
  );
}
